import { call, put, takeLatest } from 'redux-saga/effects';
import api from '../../helpers/api';
import {
  FETCH_METERS,
  FETCH_METER,
  CREATE_METER,
  UPDATE_METER,
  DELETE_METER,
  FETCH_METERS_BY_ASSET,
  FETCH_METER_READINGS,
  CREATE_METER_READING,
  FETCH_READINGS_BY_WORK_ORDER,
} from './actionTypes';
import {
  fetchMetersSuccess, fetchMetersFail,
  fetchMeterSuccess, fetchMeterFail,
  createMeterSuccess, createMeterFail,
  updateMeterSuccess, updateMeterFail,
  deleteMeterSuccess, deleteMeterFail,
  fetchMetersByAssetSuccess, fetchMetersByAssetFail,
  fetchMeterReadingsSuccess, fetchMeterReadingsFail,
  createMeterReadingSuccess, createMeterReadingFail,
  fetchReadingsByWorkOrderSuccess, fetchReadingsByWorkOrderFail,
} from './actions';

function* fetchMetersSaga({ payload: { page, size, assetId, status, search } }) {
  try {
    const params = new URLSearchParams();
    params.append('page', page || 0);
    params.append('size', size || 20);
    if (assetId) params.append('assetId', assetId);
    if (status) params.append('status', status);
    if (search) params.append('search', search);
    const { data } = yield call(api.get, `meter/list?${params.toString()}`);
    yield put(fetchMetersSuccess(data.response));
  } catch (error) {
    yield put(fetchMetersFail(error.response?.data?.message || 'Failed to fetch meters'));
  }
}

function* fetchMeterSaga({ payload: id }) {
  try {
    const { data } = yield call(api.get, `meter/get?id=${id}`);
    yield put(fetchMeterSuccess(data.response));
  } catch (error) {
    yield put(fetchMeterFail(error.response?.data?.message || 'Failed to fetch meter'));
  }
}

function* createMeterSaga({ payload: { data: meterData, callback } }) {
  try {
    const { data } = yield call(api.post, 'meter/create', meterData);
    yield put(createMeterSuccess(data.response));
    if (callback) callback();
  } catch (error) {
    yield put(createMeterFail(error.response?.data?.message || 'Failed to create meter'));
  }
}

function* updateMeterSaga({ payload: { data: meterData, callback } }) {
  try {
    const { data } = yield call(api.put, 'meter/update', meterData);
    yield put(updateMeterSuccess(data.response));
    if (callback) callback();
  } catch (error) {
    yield put(updateMeterFail(error.response?.data?.message || 'Failed to update meter'));
  }
}

function* deleteMeterSaga({ payload: { id, callback } }) {
  try {
    yield call(api.delete, `meter/delete?id=${id}`);
    yield put(deleteMeterSuccess(id));
    if (callback) callback();
  } catch (error) {
    yield put(deleteMeterFail(error.response?.data?.message || 'Failed to delete meter'));
  }
}

function* fetchMetersByAssetSaga({ payload: assetId }) {
  try {
    const { data } = yield call(api.get, `meter/by-asset?assetId=${assetId}`);
    yield put(fetchMetersByAssetSuccess(data.response));
  } catch (error) {
    yield put(fetchMetersByAssetFail(error.response?.data?.message || 'Failed to fetch meters'));
  }
}

function* fetchMeterReadingsSaga({ payload: { meterId, page, size } }) {
  try {
    const params = new URLSearchParams();
    params.append('meterId', meterId);
    params.append('page', page || 0);
    params.append('size', size || 20);
    const { data } = yield call(api.get, `meter/reading/list?${params.toString()}`);
    yield put(fetchMeterReadingsSuccess(data.response));
  } catch (error) {
    yield put(fetchMeterReadingsFail(error.response?.data?.message || 'Failed to fetch readings'));
  }
}

function* createMeterReadingSaga({ payload: { data: readingData, callback } }) {
  try {
    const { data } = yield call(api.post, 'meter/reading/create', readingData);
    yield put(createMeterReadingSuccess(data.response));
    if (callback) callback();
  } catch (error) {
    yield put(createMeterReadingFail(error.response?.data?.message || 'Failed to record reading'));
  }
}

function* fetchReadingsByWorkOrderSaga({ payload: workOrderId }) {
  try {
    const { data } = yield call(api.get, `meter/reading/by-work-order?workOrderId=${workOrderId}`);
    yield put(fetchReadingsByWorkOrderSuccess(data.response));
  } catch (error) {
    yield put(fetchReadingsByWorkOrderFail(error.response?.data?.message || 'Failed to fetch readings'));
  }
}

export default function* meterSaga() {
  yield takeLatest(FETCH_METERS, fetchMetersSaga);
  yield takeLatest(FETCH_METER, fetchMeterSaga);
  yield takeLatest(CREATE_METER, createMeterSaga);
  yield takeLatest(UPDATE_METER, updateMeterSaga);
  yield takeLatest(DELETE_METER, deleteMeterSaga);
  yield takeLatest(FETCH_METERS_BY_ASSET, fetchMetersByAssetSaga);
  yield takeLatest(FETCH_METER_READINGS, fetchMeterReadingsSaga);
  yield takeLatest(CREATE_METER_READING, createMeterReadingSaga);
  yield takeLatest(FETCH_READINGS_BY_WORK_ORDER, fetchReadingsByWorkOrderSaga);
}
